export enum EPayementType {
	customer = "customer",
	amo = "amo",
	amc = "amc",
	had = "had",
}
